module.exports = __webpack_public_path__ + "img/add-reaction.8551f090.svg";